import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    icon: {overflow: 'inherit'},
};

const ViewButtonByCustomKey = ({basePath = '', customKey = '', record = {}}) => (
    <IconButton
        containerElement={<Link to={`${basePath}/${record[customKey]}/show`}/>}
        style={styles.icon}
    >
        <ContentView color={FuseTheme.palette.primary1Color}/>
    </IconButton>
);

ViewButtonByCustomKey.propTypes = {
    basePath: PropTypes.string,
    customKey: PropTypes.string,
    record: PropTypes.object,
};

ViewButtonByCustomKey.defaultProps = {
    style: {padding: 0},
};

export default ViewButtonByCustomKey;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/ViewButtonByCustomKey.js